wbApp.directive('wbFormResponseEdit', ['$timeout', '$translate', '$q', '$window', 'formSvc', 'formResponseSvc', 'studentSvc', 'securitySvc', 'userSvc',
    function ($timeout, $translate, $q, $window, formSvc, formResponseSvc, studentSvc, securitySvc, userSvc) {

        return {
            restrict: 'A',
            scope: {
                model: '=ngModel',
                formDefinitionId: '=',
                formDefinitionRevision: '=?',
                adminEdit: '=?'
            },
            templateUrl: 'directives/forms/form-response-edit.html',
            controller: ['$scope', '$element', function ($scope, $element) {

                $scope.adminEdit = !!$scope.adminEdit && securitySvc.isInRole('FormsResponse.Insert');
                $scope.urlParams = 'returnUrl=' + encodeURIComponent(location.pathname + location.search);

                function validateModel(model)
                {
                    if ($scope.form.accessPermissions == 0 || $scope.form.accessPermissions == 3) {
                        // Login required
                        if (!$scope.isAuthenticated || !model.userId) {
                            return false;
                        }

                        if ($scope.form.accessPermissions == 0) {
                            // Student required                            
                            if (!model.studentId) {
                                return false;
                            }
                        } else {
                            if (!!model.studentId) {
                                return false;
                            }
                        }
                    } else if ($scope.form.accessPermissions == 1 || $scope.form.accessPermissions == 2) {
                        // Login is not required
                        if ($scope.form.accessPermissions == 2) {
                            // Student required
                            if ($scope.isAuthenticated && !!model.userId) {
                                if (!model.studentId) {
                                    return false;
                                }
                            } else {
                                if (!!model.studentId ||
                                    !$scope.form.notRegisteredUserInfo ||
                                    !$scope.form.notRegisteredUserInfo.students ||
                                    $scope.form.notRegisteredUserInfo.students.length != 1) {
                                    return false;
                                }
                            }
                        } else {
                            if (!!model.studentId) {
                                return false;
                            }

                            if (!!$scope.form.notRegisteredUserInfo) {
                                if (!!$scope.form.notRegisteredUserInfo.students &&
                                    !!$scope.form.notRegisteredUserInfo.students.length) {
                                    return false;
                                }
                            }
                        }

                    }
                    return $scope.dummy.editform.$valid;
                }

                function updateModel() {
                    if (!$scope.form) {
                        $scope.model.isValid = false;
                    }
                    else {
                        angular.extend($scope.model, formSvc.generateFormResponseFromFilledForm($scope.form));
                        $scope.model.isValid = validateModel($scope.model);
                    }

                    if (!!$scope.form &&
                        $scope.form.showFullEditableStudentDetail &&
                        !$scope.model.isNotRegisteredUser &&
                        $scope.isAuthenticated) {
                        if (!$scope.model.student || $scope.model.student.id != $scope.model.studentId)
                        {
                            $scope.model.student = _.find($scope.form.students, { 'checked': true });
                        }
                    }
                }

                $scope.onRegisteredBtnClick = function()
                {
                    if (!!$scope.form) {
                        $scope.form.notRegisteredUserInfo = null;
                    }
                }

                $scope.onAnonymousBtnClick = function()
                {
                    if (!!$scope.form) {
                        if (!$scope.form.notRegisteredUserInfo) {
                            if ($scope.form.accessPermissions == 2) {
                                $scope.form.notRegisteredUserInfo = {
                                    surname: null,
                                    email: null,
                                    phone: null,
                                    students: [{
                                        surname: null,
                                        birthday: null
                                    }]
                                };
                            } else {
                                $scope.form.notRegisteredUserInfo = {
                                    surname: null,
                                    email: null,
                                    phone: null,
                                    students: null
                                };
                            }
                        } else {
                            $scope.form.notRegisteredUserInfo = null;
                        }
                    }
                }

                $scope.students = [];
                $scope.images = [];
                $scope.formIsLoading = true;
                $scope.loginRequired = false;
                $scope.isNewForFilling = true;

                $scope.isAuthenticated = securitySvc.isAuthenticated();

                $scope.onAdminUserChange = function(userId)
                {
                    if (!!userId && ($scope.form.accessPermissions == 0 || $scope.form.accessPermissions == 2))
                    {
                        if (!$scope.model || $scope.model.userId != userId) {
                            if (securitySvc.isInRole('FormsResponse.Insert')) {
                                userSvc.getByIDFull(userId).$promise.then(function (user) {
                                    $scope.model.user = user;
                                });
                            } else {
                                userSvc.getCurrentAsync(userId).$promise.then(function (user) {
                                    $scope.model.user = user;
                                });
                            }
                        }

                        studentSvc.getAllByUserIDAsync(userId).$promise.then(function (students) {
                            $scope.students = angular.copy(students);
                            $scope.form.students = $scope.students;

                            if (!!$scope.form.students && $scope.form.students.length == 1) {
                                $scope.form.students[0].checked = true;
                                $scope.onCheckboxClick(0, $scope.form.students, $scope.form.students[0]);
                            }
                        });
                    }

                    if (!userId) {
                        $scope.students = [];
                        $scope.form.students = [];
                        $scope.model.user = null;
                    }
                }

                let promises = [];

                if ((typeof $scope.formDefinitionRevision === 'undefined' || $scope.formDefinitionRevision === null) && !!$scope.formDefinitionId) {
                    promises.push(formSvc.getById($scope.formDefinitionId).$promise);
                } else if (!!$scope.formDefinitionId) {
                    promises.push(formSvc.getByIdAndRevision($scope.formDefinitionId, $scope.formDefinitionRevision).$promise);
                } else {
                    promises.push($q(function (resolve, reject) { resolve({}); }));
                }

                if ($scope.isAuthenticated && !$scope.model.id) {
                    // New form filling
                    promises.push(studentSvc.getCurrentAsync().$promise);
                } else {
                    // Existing form response view
                    promises.push($q(function (resolve, reject) { resolve([]); }));
                }

                if (!!$scope.model.id) {
                    promises.push(formResponseSvc.getById($scope.model.id).$promise);
                    $scope.isNewForFilling = false;
                } else {
                    promises.push($q(function (resolve, reject) { resolve($scope.model); }))
                    $scope.isNewForFilling = true;
                }

                $q.all(promises).then(function (data) {

                    function fetchFormDefinition(model, form, students)
                    {
                        if (!$scope.formDefinitionId) {
                            // formId was not provided, fetch it from form response
                            formSvc.getByIdAndRevision(model.formDefinitionId, model.formDefinitionRevision).$promise.then(function (d) {
                                let f = angular.copy(d);
                                assignData(model, f, students);
                            });
                        } else {
                            assignData(model, form, students);
                        }
                    }

                    function assignData(model, form, students) {
                        $scope.form = form;

                        if (!!$scope.form.showFullEditableStudentDetail) {
                            model.showFullEditableStudentDetail = true;
                        }

                        if ($scope.form.showFullEditableUserDetail &&
                            !model.isNotRegisteredUser &&
                            $scope.isAuthenticated) {

                            let userId = $scope.model.userId;
                            if (!userId && !$scope.model.id) {
                                userId = securitySvc.loggedInUser().userID + '';
                            }

                            if (!!userId) {
                                $scope.model.showFullEditableUserDetail = $scope.form.showFullEditableUserDetail;

                                if (securitySvc.isInRole('FormsResponse.Insert')) {
                                    userSvc.getByIDFull(userId).$promise.then(function (user) {
                                        $scope.model.user = user;
                                    });
                                } else {
                                    userSvc.getCurrentAsync(userId).$promise.then(function (user) {
                                        $scope.model.user = user;
                                    });
                                }
                            }
                        }

                        $scope.loginRequired = !$scope.isAuthenticated && ($scope.form.accessPermissions == 0 || $scope.form.accessPermissions == 3);

                        if (!$scope.model.id) {
                            $scope.form.userId = securitySvc.loggedInUser().userID + '';
                        }

                        $scope.form.students = students;
                        if (!!$scope.model.id) {
                            formSvc.updateFilledFormByFormResponse($scope.form, $scope.model);
                        } else {
                            updateModel();
                        }                        
                        
                        if (!!$scope.form.students && $scope.form.students.length == 1 && $scope.form.accessPermissions != 1 && $scope.form.accessPermissions != 3) {
                            $scope.form.students[0].checked = true;
                            $scope.onCheckboxClick(0, $scope.form.students, $scope.form.students[0]);
                        }

                        if (!!$scope.form.pictureUrls && $scope.form.pictureUrls.length > 1) {
                            $scope.images = _.map($scope.form.pictureUrls, function (p) {
                                return {
                                    thumb: p,
                                    img: p
                                };
                            });
                        }

                        $scope.formIsLoading = false;
                    }

                    let form = angular.copy(data[0]);
                    let students = angular.copy(data[1]);
                    let model = angular.extend($scope.model, data[2]);
                    
                    if (!!$scope.model.id && !model.isNotRegisteredUser) {
                        // Fetch correct students, user might not be current user
                        studentSvc.getAllByUserIDAsync($scope.model.userId).$promise.then(function (st) {
                            students = angular.copy(st);
                            fetchFormDefinition(model, form, students);
                        });
                    } else {
                        fetchFormDefinition(model, form, students);
                    }

                }, function (error) {
                    $scope.formIsLoading = false;
                });

                $scope.onCheckboxClick = function (questionType, options, option) {
                    // Single select
                    if (questionType == 0 || questionType == 2)
                    {
                        _.forEach(options, function (o) {
                            if (o.id == option.id) {
                                o.checked = true;
                            } else {
                                o.checked = false;
                            }
                        });
                    } else {
                        var numOfSelected = _.reduce(options, function (numOfSelected, o) {
                            return numOfSelected + (!!o.checked ? 1 : 0);
                        }, 0);

                        if (!numOfSelected) {
                            option.checked = true;
                        }
                    }
                    updateModel();
                }

                $scope.onTextEdit = function()
                {
                    updateModel();
                }

                $scope.$watch('form', function () {
                    $timeout(function () {
                        updateModel();
                    }, 100);
                }, true);
            }],

            link: function ($scope, $element, attrs, ctrl) {
            }
        }
    }]);